import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { createHead, getPubSearch } from '~/utils';
import { useArchive, useBrandvoices, useSearch } from '~/composables';
import { useDuck } from '~/services';
/**
 * Duck service.
 */
const duck = useDuck();
export default defineComponent({
    name: 'PageArchiveChild',
    setup() {
        /**
         * Composables
         */
        const archive = useArchive();
        const css = useCssModule();
        const search = useSearch();
        return {
            archive,
            css,
            search,
        };
    },
    async asyncData(context) {
        const { $dayjs, $pinia, app, env, error, route } = context;
        try {
            const archive = useArchive($pinia);
            const brandvoices = useBrandvoices($pinia);
            const search = useSearch($pinia);
            search.set('notFound', false);
            search.set('isLoading', true);
            await brandvoices.fetch();
            const { data: articles, headers } = await getPubSearch({
                brandvoices,
                duck,
                route,
            }, {
                'list[limit]': search.limit,
                'list[offset]': 0,
                'node[title]': search.query,
                ...(search.dateRange.length && {
                    'node[sort]': search.backendSortType,
                    'node[start]': String($dayjs(search.dateRange[0], search.dateFormat).unix()),
                    'node[end]': String($dayjs(search.dateRange[1], search.dateFormat)
                        .startOf('day')
                        .add(23, 'hour')
                        .add(59, 'minute')
                        .add(59, 'second')
                        .unix()),
                }),
            });
            if (!articles.length) {
                search.set('notFound', true);
            }
            search.set('completedQuery', search.query);
            const { path, params: { pathMatch = '' }, } = route;
            search.set('articles', articles);
            const total = Number(headers?.get('x-total-count')) || 0;
            search.set('total', total);
            const archivePath = pathMatch?.replace(/\/$/, '') || '';
            const title = `${archive.get(archivePath, 'title')} | Архив`;
            const head = {
                canonical: env.HOST + path,
                title,
                url: env.HOST + path,
            };
            context.$page = app.$page = {
                title,
            };
            search.set('isLoading', false);
            return {
                $page: context.$page,
                articles,
                head,
                total,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
